<template>
  <div>
    <c-q-separator class="q-pb-lg" :withBackButton="true" />

    <PageCaption
      pageCaptionTitle="Novo Cadastro de Telas Institucionais"
      pageCaptionDescription="Envie um novo Cadastro de Telas Institucionais para Aprovação"
    />

    <InstitutionalIdentificationSectionEdit />

    <InstitutionalFormatSectionEdit />

    <c-q-separator class="q-pt-lg q-pb-lg" />

    <!-- ✅ Adicionar ref aqui -->
    <InstitutionalAccordion
      ref="accordionRef"
      mode="edit"

      :accordionsData="institutionalNewData?.accordions"
    />

    <c-q-separator class="q-pt-lg q-pb-lg" />

    <!-- ✅ PASSAR accordionRef PARA O BOTÃO -->
    <InstitutionalActionButtonsSection 
      :propShowBtnCancelCreateNewCampaign="true"
      :propShowBtnReviewFocusedCampaign="true"
      :accordionRef="accordionRef"
    />
  </div>
</template>

<script setup lang="ts">
import PageCaption from '@/components/PageCaption.vue';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue';
import InstitutionalIdentificationSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionEdit.vue';
import InstitutionalFormatSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalFormatSectionEdit.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import { ref, computed } from 'vue';
import { useInstitutionalStore } from '@/stores/institutionalStore';

const institutionalStore = useInstitutionalStore()

const institutionalNewData = computed(() => {
  if (!institutionalStore.veioDaReview) return null

  const imagens = institutionalStore.imagensDraft || []

  const mapTempo = (posicao: number) => {
    const img = imagens.find(i => i.posicaoImagem === posicao)
    return img?.duracaoImagem || 10
  }

  return {
    id: 'NEW',
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, tempo: mapTempo(1) },
        { id: 2, tela: 'Tela 2', posicao: 2, tempo: mapTempo(2) },
        { id: 3, tela: 'Tela 3', posicao: 3, tempo: mapTempo(3) },
        { id: 4, tela: 'Tela 4', posicao: 4, tempo: mapTempo(4) }
      ],
      telasAtm: [
        { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
        { id: 9, botao: 'Recarga celular', posicao: 9 },
        { id: 10, botao: 'Mais serviços', posicao: 10 },
        { id: 11, botao: 'Depositar dinheiro', posicao: 11 }
      ],
      telasAguardeGeral: [{ id: 6, tela: 'Tela Geral', posicao: 6 }],
      telasAguardeChip: [{ id: 7, tela: 'Tela Chip', posicao: 7 }],
      telasAbertura: [{ id: 5, tela: 'Tela Abertura', posicao: 5 }],

      imagens,
      corTexto: institutionalStore.reviewData?.corTexto ?? null,
      exibeTelaAbertura: institutionalStore.exibeTelaAberturaRascunho
    }
  }
})


// ✅ Ref para acessar o accordion
const accordionRef = ref();
</script>

<style scoped>

</style>
